// config/theme.js
export const brandColors = {
    primary: '#ff660e',
    primaryLight: '#ff8536',
    primaryDark: '#e65c00',
    secondary: '#1a1a1a',
    accent: '#10b981',
    danger: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6',
    light: '#f8fafc',
    dark: '#1e293b',
    gray: '#64748b',
    grayLight: '#e2e8f0'
  };
  
  export const theme = {
    colors: brandColors,
    shadows: {
      sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
      md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
    },
    borderRadius: {
      sm: '0.375rem',
      md: '0.5rem',
      lg: '0.75rem',
      xl: '1rem'
    }
  };